// extracted by mini-css-extract-plugin
module.exports = {"iconLabeled":"iconLabeled-module--iconLabeled--2xKff","label":"iconLabeled-module--label--aaUv8"};